"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.567 5.7a2.7 2.7 0 0 1 2.7-2.7h9.283a2.7 2.7 0 0 1 2.7 2.7v.744a2.7 2.7 0 0 1-2.7 2.7H6.267a2.7 2.7 0 0 1-2.7-2.7zm2.7-1.3a1.3 1.3 0 0 0-1.3 1.3v.744a1.3 1.3 0 0 0 1.3 1.3h9.283a1.3 1.3 0 0 0 1.3-1.3V5.7a1.3 1.3 0 0 0-1.3-1.3zm2.518 11.273a2.123 2.123 0 0 1 4.247 0v3.204a2.123 2.123 0 0 1-4.247 0zm2.124-.723c-.4 0-.724.324-.724.723v3.204a.723.723 0 0 0 1.447 0v-3.204c0-.4-.324-.723-.723-.723",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.233 6.772H17.11v-1.4h1.122a2.2 2.2 0 0 1 2.2 2.2V9.21a2.45 2.45 0 0 1-2.45 2.45h-5.574a.8.8 0 0 0-.8.8v1.646h-1.4V12.46a2.2 2.2 0 0 1 2.2-2.2h5.574c.58 0 1.05-.47 1.05-1.05V7.572a.8.8 0 0 0-.8-.8",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=PaintRollerIcon24.js.map